import React from 'react';
import { type DialogProps, Slide, type SlideProps } from '@material-ui/core';

type TransitionComponent = NonNullable<DialogProps['TransitionComponent']>;

type TransitionComponentProps = React.ComponentProps<TransitionComponent> & {
  // Dialog may pass this through, but it causes accessibility issues;
  // we intentionally drop it before forwarding to the transition
  tabIndex?: number;
};

const ensureElement = (children: React.ReactNode): React.ReactElement => (
  React.isValidElement(children) ? children : <div>{children}</div>
);

// If transitions other than Slide get added, extract a transitionComponent(render, displayName) helper
export const slideComponent = (direction: SlideProps['direction'], displayName: string): TransitionComponent => {
  const Component: TransitionComponent = React.forwardRef<unknown, TransitionComponentProps>((props, ref) => {
    // Remove tabIndex from transition component to avoid accessibility issues
    const { tabIndex, children, ...restProps } = props;
    return <Slide ref={ref} direction={direction} {...restProps}>{ensureElement(children)}</Slide>;
  });
  Component.displayName = displayName;
  return Component;
};
